import {defineStore} from 'pinia'
import {getStoreSets} from '@/api/storeSets'
import {getOptionSets} from '@/api/options'
import {OptionSet, StoreSet} from '@/models/StoreAndOptionSets'
import {useGeneralStore} from '@/store/pinia/generalStore'

export const useStoreAndOptionSetsStore = defineStore('storesAndOptionSets', {
  state: () => ({
    optionSets: [] as OptionSet[],
    loadingOptionSets: false,
    loadingStoreSetsLabel: 'all',
    loadingOptionSetsLabel: 'all',
    loadedStoreSetsLabel: null as string | null,
    loadedOptionSetsLabel: null as string | null,
    storeSets: [] as StoreSet[],
    loadingStoreSets: false,
  }),
  actions: {
    async loadStoreSets (force = false) {
      try {
        const storesLabel = useGeneralStore().currentStoresSetsLabel || 'all'

        if (!force) {
          if (storesLabel === this.loadedStoreSetsLabel && this.storeSets.length > 0) {
            return
          }
          if (storesLabel === this.loadingStoreSetsLabel && this.loadingStoreSets) {
            return
          }
        }

        const requestLabel = storesLabel
        this.loadingStoreSets = true
        this.loadingStoreSetsLabel = requestLabel
        const label = requestLabel === 'all' ? '' : `?label=${requestLabel}`
        const response = await getStoreSets(label)

        if (this.loadingStoreSetsLabel !== requestLabel) {
          return
        }
        this.storeSets = response?.stores_sets ?? []
        this.loadedStoreSetsLabel = requestLabel
      } finally {
        this.loadingStoreSets = false
      }
    },
    async loadOptionSets (force = false) {
      try {
        const optionsLabel = useGeneralStore().currentStoresSetsLabel || 'all'

        if (!force) {
          if (optionsLabel === this.loadedOptionSetsLabel && this.optionSets.length > 0) {
            return
          }
          if (optionsLabel === this.loadingOptionSetsLabel && this.loadingOptionSets) {
            return
          }
        }

        const requestLabel = optionsLabel
        this.loadingOptionSetsLabel = requestLabel
        this.loadingOptionSets = true
        const label = requestLabel === 'all' ? '' : `?label=${requestLabel}`
        const response = await getOptionSets(label)

        if (this.loadingOptionSetsLabel !== requestLabel) {
          return
        }
        this.optionSets = response?.options_sets ?? []
        this.loadedOptionSetsLabel = requestLabel
      } finally {
        this.loadingOptionSets = false
      }
    }
  }
})
